import React, {useEffect, useRef, useState} from 'react';
import {Box, Button, Flex, Text, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody} from '@chakra-ui/react';
import {Link, useSearchParams} from 'react-router-dom';
import {getReviewItem} from '../../utils/apis/agentApi';
import ReviewIssue from './ReviewIssue';

export default function ConversationIssues({phone, flags, onResolved}: {
  phone: string; flags: any[]; onResolved: (issue: any) => void;
}) {
  const [params] = useSearchParams();
  const [linked, setLinked] = useState<any>(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [retry, setRetry] = useState(0);
  const [open, setOpen] = useState(false);
  const trigger = useRef<HTMLButtonElement>(null);
  const requestVersion = useRef(0);
  const flag = params.get('flag'), caseId = params.get('case'), linkedPhone = params.get('phone');
  useEffect(() => {setOpen(Boolean((flag || caseId) && linkedPhone === phone));}, [phone, flag, caseId, linkedPhone]);
  useEffect(() => {
    let current = true;
    const version = ++requestVersion.current;
    setLinked(null); setError(false);
    if ((!flag && !caseId) || linkedPhone !== phone) {setLoading(false); return;}
    setLoading(true);
    getReviewItem(flag, caseId).then(result => {
      if (!current || requestVersion.current !== version) return;
      setLoading(false);
      if (result.ok && result.data?.phone_number === phone) setLinked(result.data);
      else setError(true);
    });
    return () => {current = false;};
  }, [phone, flag, caseId, linkedPhone, retry]);
  const issues = [...(linked ? [linked] : []), ...flags.filter(f => !f.resolved && (!linked || f.id !== linked.id))];
  const unresolved = issues.filter(issue => !issue.resolved).length;
  return <Box px={3} py={2} borderBottomWidth="1px" flexShrink={0}>
    <Flex align="center" justify="space-between" gap={2}>
      <Button ref={trigger} size="sm" variant="outline" onClick={() => setOpen(true)}
        aria-haspopup="dialog" aria-expanded={open}>Issues{unresolved ? ` (${unresolved})` : ''}</Button>
    <Button as={Link} to="/flag-review" size="sm" variant="link">Review Queue</Button>
    </Flex>
    <Drawer isOpen={open} onClose={() => setOpen(false)} placement="right" size="md" finalFocusRef={trigger}>
      <DrawerOverlay />
      <DrawerContent maxW={{base: '100%', md: '480px'}}>
        <DrawerCloseButton aria-label="Close issues" />
        <DrawerHeader borderBottomWidth="1px">Conversation issues{unresolved ? ` (${unresolved} open)` : ''}</DrawerHeader>
        <DrawerBody px={4} py={3}>
    {loading && <Text fontSize="sm">Loading linked issue…</Text>}
    {error && <Box><Text role="alert">Could not load the linked issue.</Text><Button size="sm" onClick={() => setRetry(n => n + 1)}>Retry issue</Button></Box>}
    {!loading && !error && !issues.length && <Text>No open issues for this conversation.</Text>}
    {issues.map(issue => <Box key={issue.id || `case-${issue.case_id}`} mt={2}>
      <ReviewIssue issue={issue} inConversation onResolved={updated => {
        requestVersion.current += 1;
        setLoading(false);
        if (String(updated.id) === flag || String(updated.case_id) === caseId) setLinked(updated);
        if (!flag && !caseId && unresolved === 1) setOpen(false);
        onResolved(updated);
      }} />
    </Box>)}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  </Box>;
}
